// Game Engine API Service (Legacy Compatibility Layer)
// This file maintains backward compatibility while using the new modular services

// Import the new services for legacy compatibility
import { gameEngineService, GameUtils } from './api';

// Re-export everything from the new modular API
export * from './api';

// Legacy class-based API for backward compatibility
export default class GameEngineAPI {
  /**
   * Create a new game session
   */
  static async createGame(
    gameType: 'classic-ludo' | 'naija-ludo' = 'classic-ludo',
    maxPlayers: number = 4,
    isPrivate: boolean = false
  ) {
    return gameEngineService.createGame(gameType, maxPlayers, isPrivate);
  }

  /**
   * Join an existing game
   */
  static async joinGame(gameId: string) {
    return gameEngineService.joinGame(gameId);
  }

  /**
   * Start a game (move from waiting to active phase)
   */
  static async startGame(gameId: string) {
    return gameEngineService.startGame(gameId);
  }

  /**
   * Roll dice - server-generated cryptographically secure
   */
  static async rollDice(gameId: string) {
    return gameEngineService.rollDice(gameId);
  }

  /**
   * Make a move (legacy method)
   */
  static async makeMove(
    gameId: string,
    pieceId: string,
    fromPosition: number,
    toPosition: number,
    diceValue: number
  ) {
    return gameEngineService.makeMove(
      gameId,
      pieceId,
      fromPosition,
      toPosition,
      diceValue
    );
  }

  /**
   * Move a piece
   */
  static async movePiece(
    gameId: string,
    pieceId: string,
    diceValue: number,
    fromPosition?: number,
    toPosition?: number
  ) {
    return gameEngineService.movePiece(
      gameId,
      pieceId,
      diceValue,
      fromPosition,
      toPosition
    );
  }

  /**
   * Get current game state
   */
  static async getGameState(gameId: string) {
    return gameEngineService.getGameState(gameId);
  }

  /**
   * Leave a game
   */
  static async leaveGame(gameId: string) {
    return gameEngineService.leaveGame(gameId);
  }

  /**
   * Get player's current active game
   */
  static async getPlayerGame() {
    return gameEngineService.getPlayerGame();
  }

  /**
   * Get list of active games
   */
  static async getActiveGames() {
    return gameEngineService.getActiveGames();
  }
}

// Legacy utilities class for backward compatibility
export class GameEngineUtils {
  /**
   * Convert backend game state to frontend format
   */
  static convertBackendGameState(backendState: any) {
    return GameUtils.convertBackendGameState(backendState);
  }

  /**
   * Map backend player color to frontend color
   */
  static mapPlayerColor(backendColor: string) {
    return GameUtils.mapPlayerColor(backendColor);
  }

  /**
   * Check if a piece can move based on available moves
   */
  static canPieceMove(pieceId: string, availableMoves: any[]) {
    return GameUtils.canPieceMove(pieceId, availableMoves);
  }

  /**
   * Get valid moves for a specific piece
   */
  static getValidMovesForPiece(pieceId: string, availableMoves: any[]) {
    return GameUtils.getValidMovesForPiece(pieceId, availableMoves);
  }
}
